var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { id: "registrationModal", "hide-footer": true },
      model: {
        value: _vm.modalShow,
        callback: function ($$v) {
          _vm.modalShow = $$v
        },
        expression: "modalShow",
      },
    },
    [
      _vm.modalData == "BALLOT"
        ? _c(
            "div",
            { attrs: { id: "ballotForm" } },
            [
              _c(
                "div",
                { staticClass: "formTitle" },
                [
                  _c("svg-image", { attrs: { image: "iconBallot" } }),
                  _vm._v(" "),
                  _c("h5", [_vm._v(_vm._s(_vm.$t("register.ballot")))]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form",
                { on: { submit: _vm.doRegister } },
                [
                  _c("div", { staticClass: "groupLabel" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("register.form.detail.label"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.detail.race"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.raced"),
                      },
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          model: {
                            value: _vm.form.evpaEvncId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "evpaEvncId", $$v)
                            },
                            expression: "form.evpaEvncId",
                          },
                        },
                        [
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "744" } },
                            [_vm._v("10K")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "743" } },
                            [_vm._v("Half Marathon")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "742" } },
                            [_vm._v("Marathon")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "evpaWave-group",
                        label: _vm.$t("register.form.detail.time"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.timed"),
                      },
                    },
                    [
                      _c("vue-timepicker", {
                        staticClass: "timepicker",
                        attrs: {
                          "hour-range": _vm.waveRange,
                          "input-class": "form-control",
                        },
                        model: {
                          value: _vm.form.evpaWave,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaWave", $$v)
                          },
                          expression: "form.evpaWave",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.detail.bib"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.bibd"),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "",
                          required: "",
                          placeholder: "",
                          maxlength: "16",
                        },
                        model: {
                          value: _vm.form.evpaBIBName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaBIBName", $$v)
                          },
                          expression: "form.evpaBIBName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "community-group",
                        label: _vm.$t("register.form.detail.comm"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.commd"),
                      },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.communities,
                          "create-option": (option) => option,
                          taggable: true,
                          label: "evpaCommunity",
                        },
                        model: {
                          value: _vm.form.evpaCommunity,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaCommunity", $$v)
                          },
                          expression: "form.evpaCommunity",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "groupLabel" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("register.form.emergency.label"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.emergency.name"),
                        "label-for": "",
                        description: _vm.$t("register.form.emergency.named"),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "", required: "", placeholder: "" },
                        model: {
                          value: _vm.form.evpaEmergencyContactName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaEmergencyContactName", $$v)
                          },
                          expression: "form.evpaEmergencyContactName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "phone-group",
                        label: _vm.$t("register.form.emergency.number"),
                        "label-for": "phone",
                        description: "",
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { id: "phone-group", "label-for": "phone" } },
                        [
                          _c("VuePhoneNumberInput", {
                            staticClass: "form-group",
                            attrs: {
                              "no-example": "",
                              color: "#ea0c0c",
                              "border-radius": 0,
                              required: "",
                              "default-country-code": "ID",
                            },
                            on: { update: _vm.phoneUpdated },
                            model: {
                              value: _vm.form_.evpaEmergencyContactNumber,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form_,
                                  "evpaEmergencyContactNumber",
                                  $$v
                                )
                              },
                              expression: "form_.evpaEmergencyContactNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.emergency.medic"),
                        "label-for": "",
                        description: _vm.$t("register.form.emergency.medicd"),
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "textarea",
                          placeholder: "",
                          rows: "2",
                          "max-rows": "6",
                        },
                        model: {
                          value: _vm.form.evpaMedicalTreatment,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaMedicalTreatment", $$v)
                          },
                          expression: "form.evpaMedicalTreatment",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        id: "acceptance",
                        name: "acceptance",
                        value: "accepted",
                        "unchecked-value": "not_accepted",
                      },
                      model: {
                        value: _vm.formChecked,
                        callback: function ($$v) {
                          _vm.formChecked = $$v
                        },
                        expression: "formChecked",
                      },
                    },
                    [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("register.form.acceptance")),
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "clearfix" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            block: "",
                            type: "submit",
                            variant: "primary",
                            size: "lg",
                            disabled:
                              _vm.loading || _vm.formChecked !== "accepted",
                          },
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", {
                                attrs: { small: "", type: "grow" },
                              })
                            : _vm._e(),
                          _vm._v(" " + _vm._s(_vm.$t("register.form.btn"))),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modalData == "FRQ"
        ? _c(
            "div",
            { attrs: { id: "frqForm" } },
            [
              _c(
                "div",
                { staticClass: "formTitle" },
                [
                  _c("svg-image", { attrs: { image: "iconFRQ" } }),
                  _vm._v(" "),
                  _c("h5", [_vm._v(_vm._s(_vm.$t("register.frq")))]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form",
                { on: { submit: _vm.doRegister } },
                [
                  _c("div", { staticClass: "groupLabel" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("register.form.detail.label"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "evpaEvncId",
                        label: _vm.$t("register.form.detail.race"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.raced"),
                      },
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          model: {
                            value: _vm.form.evpaEvncId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "evpaEvncId", $$v)
                            },
                            expression: "form.evpaEvncId",
                          },
                        },
                        [
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "744" } },
                            [_vm._v("10K")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "743" } },
                            [_vm._v("Half Marathon")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "742" } },
                            [_vm._v("Marathon")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.detail.bib"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.bibd"),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "",
                          required: "",
                          placeholder: "",
                          maxlength: "16",
                        },
                        model: {
                          value: _vm.form.evpaBIBName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaBIBName", $$v)
                          },
                          expression: "form.evpaBIBName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "community-group",
                        label: _vm.$t("register.form.detail.comm"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.commd"),
                      },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.communities,
                          "create-option": (option) => option,
                          taggable: true,
                          label: "evpaCommunity",
                        },
                        model: {
                          value: _vm.form.evpaCommunity,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaCommunity", $$v)
                          },
                          expression: "form.evpaCommunity",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "groupLabel" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("register.form.frq.label"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.frq.qrace"),
                        "label-for": "",
                        description: _vm.$t("register.form.frq.qraced"),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "mmfrEventName",
                          required: "",
                          placeholder: "",
                        },
                        model: {
                          value: _vm.form.mmfrEventName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mmfrEventName", $$v)
                          },
                          expression: "form.mmfrEventName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("register.form.frq.qcat"),
                        id: "mmfrDescription",
                        "label-for": "evpaFRrace",
                        description: _vm.$t("register.form.frq.qcatd"),
                      },
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          model: {
                            value: _vm.form.mmfrDescription,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "mmfrDescription", $$v)
                            },
                            expression: "form.mmfrDescription",
                          },
                        },
                        [
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "10K" } },
                            [_vm._v("10K")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "HalfMarathon" } },
                            [_vm._v("Half Marathon")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "Marathon" } },
                            [_vm._v("Marathon")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.frq.qtime"),
                        "label-for": "evpaFRtime",
                        description: _vm.$t("register.form.frq.qtimed"),
                      },
                    },
                    [
                      _c("vue-timepicker", {
                        staticClass: "timepicker",
                        attrs: {
                          "input-class": "form-control",
                          format: "hh:mm:ss",
                        },
                        model: {
                          value: _vm.form.mmfrResultTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mmfrResultTime", $$v)
                          },
                          expression: "form.mmfrResultTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.frq.qfile"),
                        "label-for": "evpaFRcertificate",
                        description: _vm.$t("register.form.frq.qfiled"),
                      },
                    },
                    [
                      _c("b-form-file", {
                        attrs: {
                          placeholder: _vm.$t("validate.id.placefile"),
                          "drop-placeholder": _vm.$t("validate.id.dropfile"),
                          accept: ".jpg, .png, .pdf",
                        },
                        on: { change: _vm.handleFileUpload },
                        model: {
                          value: _vm.certificateFile,
                          callback: function ($$v) {
                            _vm.certificateFile = $$v
                          },
                          expression: "certificateFile",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-progress",
                        {
                          staticClass: "mt-2",
                          attrs: { max: 200, height: "2.5rem" },
                        },
                        [
                          _c(
                            "b-progress-bar",
                            { attrs: { value: _vm.progress } },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" + _vm._s(_vm.progressAction)
                              ),
                              _c("strong", [_vm._v(_vm._s(_vm.progress / 2))]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c("label", { staticClass: "fileLabel" }, [
                          _vm._v(
                            _vm._s(_vm.$t("validate.id.labelselect")) +
                              " " +
                              _vm._s(
                                _vm.certificateFile
                                  ? _vm.certificateFile.name
                                  : ""
                              )
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.frq.qurl"),
                        "label-for": "evpaFRrace",
                        description: _vm.$t("register.form.frq.qurld"),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "",
                          type: "url",
                          placeholder: _vm.$t("register.form.frq.qurlp"),
                        },
                        model: {
                          value: _vm.form.mmfrResultLink,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mmfrResultLink", $$v)
                          },
                          expression: "form.mmfrResultLink",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "groupLabel" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("register.form.emergency.label"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.emergency.name"),
                        "label-for": "",
                        description: _vm.$t("register.form.emergency.named"),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "", required: "", placeholder: "" },
                        model: {
                          value: _vm.form.evpaEmergencyContactName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaEmergencyContactName", $$v)
                          },
                          expression: "form.evpaEmergencyContactName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "phone-group",
                        label: _vm.$t("register.form.emergency.number"),
                        "label-for": "phone",
                        description: "",
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { id: "phone-group", "label-for": "phone" } },
                        [
                          _c("VuePhoneNumberInput", {
                            staticClass: "form-group",
                            attrs: {
                              "no-example": "",
                              color: "#ea0c0c",
                              "border-radius": 0,
                              required: "",
                              "default-country-code": "ID",
                            },
                            on: { update: _vm.phoneUpdated },
                            model: {
                              value: _vm.form_.evpaEmergencyContactNumber,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form_,
                                  "evpaEmergencyContactNumber",
                                  $$v
                                )
                              },
                              expression: "form_.evpaEmergencyContactNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.emergency.medic"),
                        "label-for": "",
                        description: _vm.$t("register.form.emergency.medicd"),
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "textarea",
                          placeholder: "",
                          rows: "2",
                          "max-rows": "6",
                        },
                        model: {
                          value: _vm.form.evpaMedicalTreatment,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaMedicalTreatment", $$v)
                          },
                          expression: "form.evpaMedicalTreatment",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        id: "acceptance",
                        name: "acceptance",
                        value: "accepted",
                        "unchecked-value": "not_accepted",
                      },
                      model: {
                        value: _vm.formChecked,
                        callback: function ($$v) {
                          _vm.formChecked = $$v
                        },
                        expression: "formChecked",
                      },
                    },
                    [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("register.form.acceptance")),
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("alert", { attrs: { status: _vm.status } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "clearfix" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            block: "",
                            type: "submit",
                            variant: "primary",
                            size: "lg",
                            disabled:
                              _vm.loading || _vm.formChecked !== "accepted",
                          },
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", {
                                attrs: { small: "", type: "grow" },
                              })
                            : _vm._e(),
                          _vm._v(" " + _vm._s(_vm.$t("register.form.btn"))),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modalData == "JATENG"
        ? _c(
            "div",
            { attrs: { id: "bankForm" } },
            [
              _c(
                "div",
                { staticClass: "formTitle" },
                [
                  _c("svg-image", { attrs: { image: "iconBank" } }),
                  _vm._v(" "),
                  _c("h5", [_vm._v(_vm._s(_vm.$t("register.bankjateng")))]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form",
                { on: { submit: _vm.doRegister } },
                [
                  _c("div", { staticClass: "groupLabel" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("register.form.voucher.label"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.voucher.code"),
                        "label-for": "",
                        description: _vm.$t("register.form.voucher.bjcode"),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "", required: "", placeholder: "" },
                        model: {
                          value: _vm.form.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "code", $$v)
                          },
                          expression: "form.code",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "groupLabel" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("register.form.detail.label"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.detail.race"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.raced"),
                      },
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          model: {
                            value: _vm.form.evpaEvncId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "evpaEvncId", $$v)
                            },
                            expression: "form.evpaEvncId",
                          },
                        },
                        [
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "744" } },
                            [_vm._v("10K")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "743" } },
                            [_vm._v("Half Marathon")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "742" } },
                            [_vm._v("Marathon")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "evpaWave-group",
                        label: _vm.$t("register.form.detail.time"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.timed"),
                      },
                    },
                    [
                      _c("vue-timepicker", {
                        staticClass: "timepicker",
                        attrs: { "input-class": "form-control" },
                        model: {
                          value: _vm.form.evpaWave,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaWave", $$v)
                          },
                          expression: "form.evpaWave",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.detail.bib"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.bibd"),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "",
                          required: "",
                          placeholder: "",
                          maxlength: "16",
                        },
                        model: {
                          value: _vm.form.evpaBIBName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaBIBName", $$v)
                          },
                          expression: "form.evpaBIBName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: "https://assets.heartwork.co.id/bormar/jersey.jpg",
                      alt: "Jersey",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.detail.jersey"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.jerseyd"),
                      },
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          model: {
                            value: _vm.form.evpaJersey,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "evpaJersey", $$v)
                            },
                            expression: "form.evpaJersey",
                          },
                        },
                        [
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "XS" } },
                            [_vm._v("XS")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "S" } },
                            [_vm._v("S")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "M" } },
                            [_vm._v("M")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "M" } },
                            [_vm._v("L")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "XL" } },
                            [_vm._v("XL")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "2XL" } },
                            [_vm._v("XXL")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "3XL" } },
                            [_vm._v("XXXL")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "community-group",
                        label: _vm.$t("register.form.detail.comm"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.commd"),
                      },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.communities,
                          "create-option": (option) => option,
                          taggable: true,
                          label: "evpaCommunity",
                        },
                        model: {
                          value: _vm.form.evpaCommunity,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaCommunity", $$v)
                          },
                          expression: "form.evpaCommunity",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "groupLabel" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("register.form.emergency.label"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.emergency.name"),
                        "label-for": "",
                        description: _vm.$t("register.form.emergency.named"),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "", required: "", placeholder: "" },
                        model: {
                          value: _vm.form.evpaEmergencyContactName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaEmergencyContactName", $$v)
                          },
                          expression: "form.evpaEmergencyContactName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "phone-group",
                        label: _vm.$t("register.form.emergency.number"),
                        "label-for": "phone",
                        description: "",
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { id: "phone-group", "label-for": "phone" } },
                        [
                          _c("VuePhoneNumberInput", {
                            staticClass: "form-group",
                            attrs: {
                              "no-example": "",
                              color: "#ea0c0c",
                              "border-radius": 0,
                              required: "",
                              "default-country-code": "ID",
                            },
                            on: { update: _vm.phoneUpdated },
                            model: {
                              value: _vm.form_.evpaEmergencyContactNumber,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form_,
                                  "evpaEmergencyContactNumber",
                                  $$v
                                )
                              },
                              expression: "form_.evpaEmergencyContactNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.emergency.medic"),
                        "label-for": "",
                        description: _vm.$t("register.form.emergency.medicd"),
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "textarea",
                          placeholder: "",
                          rows: "2",
                          "max-rows": "6",
                        },
                        model: {
                          value: _vm.form.evpaMedicalTreatment,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaMedicalTreatment", $$v)
                          },
                          expression: "form.evpaMedicalTreatment",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        id: "acceptance",
                        name: "acceptance",
                        value: "accepted",
                        "unchecked-value": "not_accepted",
                      },
                      model: {
                        value: _vm.formChecked,
                        callback: function ($$v) {
                          _vm.formChecked = $$v
                        },
                        expression: "formChecked",
                      },
                    },
                    [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("register.form.acceptance")),
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "clearfix" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            block: "",
                            type: "submit",
                            variant: "primary",
                            size: "lg",
                            disabled: _vm.loading,
                          },
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", {
                                attrs: { small: "", type: "grow" },
                              })
                            : _vm._e(),
                          _vm._v(" " + _vm._s(_vm.$t("register.form.btn"))),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modalData == "TRAVEL"
        ? _c(
            "div",
            { attrs: { id: "travelForm" } },
            [
              _c(
                "div",
                { staticClass: "formTitle" },
                [
                  _c("svg-image", { attrs: { image: "iconTravel" } }),
                  _vm._v(" "),
                  _c("h5", [_vm._v(_vm._s(_vm.$t("register.travel")))]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form",
                { on: { submit: _vm.doRegister } },
                [
                  _c("div", { staticClass: "groupLabel" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("register.form.voucher.label"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.voucher.code"),
                        "label-for": "",
                        description: _vm.$t("register.form.voucher.trcode"),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "", required: "", placeholder: "" },
                        model: {
                          value: _vm.form.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "code", $$v)
                          },
                          expression: "form.code",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "groupLabel" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("register.form.detail.label"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.detail.race"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.raced"),
                      },
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          model: {
                            value: _vm.form.evpaEvncId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "evpaEvncId", $$v)
                            },
                            expression: "form.evpaEvncId",
                          },
                        },
                        [
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "744" } },
                            [_vm._v("10K")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "743" } },
                            [_vm._v("Half Marathon")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "742" } },
                            [_vm._v("Marathon")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "evpaWave-group",
                        label: _vm.$t("register.form.detail.time"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.timed"),
                      },
                    },
                    [
                      _c("vue-timepicker", {
                        staticClass: "timepicker",
                        attrs: { "input-class": "form-control" },
                        model: {
                          value: _vm.form.evpaWave,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaWave", $$v)
                          },
                          expression: "form.evpaWave",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.detail.bib"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.bibd"),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "",
                          required: "",
                          placeholder: "",
                          maxlength: "16",
                        },
                        model: {
                          value: _vm.form.evpaBIBName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaBIBName", $$v)
                          },
                          expression: "form.evpaBIBName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: "https://assets.heartwork.co.id/bormar/jersey.jpg",
                      alt: "Jersey",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.detail.jersey"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.jerseyd"),
                      },
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          model: {
                            value: _vm.form.evpaJersey,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "evpaJersey", $$v)
                            },
                            expression: "form.evpaJersey",
                          },
                        },
                        [
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "XS" } },
                            [_vm._v("XS")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "S" } },
                            [_vm._v("S")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "M" } },
                            [_vm._v("M")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "M" } },
                            [_vm._v("L")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "XL" } },
                            [_vm._v("XL")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "2XL" } },
                            [_vm._v("XXL")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-select-option",
                            { attrs: { value: "3XL" } },
                            [_vm._v("XXXL")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "community-group",
                        label: _vm.$t("register.form.detail.comm"),
                        "label-for": "",
                        description: _vm.$t("register.form.detail.commd"),
                      },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.communities,
                          "create-option": (option) => option,
                          taggable: true,
                          label: "evpaCommunity",
                        },
                        model: {
                          value: _vm.form.evpaCommunity,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaCommunity", $$v)
                          },
                          expression: "form.evpaCommunity",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "groupLabel" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("register.form.emergency.label"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.emergency.name"),
                        "label-for": "",
                        description: _vm.$t("register.form.emergency.named"),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "", required: "", placeholder: "" },
                        model: {
                          value: _vm.form.evpaEmergencyContactName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaEmergencyContactName", $$v)
                          },
                          expression: "form.evpaEmergencyContactName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "phone-group",
                        label: _vm.$t("register.form.emergency.number"),
                        "label-for": "phone",
                        description: "",
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { id: "phone-group", "label-for": "phone" } },
                        [
                          _c("VuePhoneNumberInput", {
                            staticClass: "form-group",
                            attrs: {
                              "no-example": "",
                              color: "#ea0c0c",
                              "border-radius": 0,
                              required: "",
                              "default-country-code": "ID",
                            },
                            on: { update: _vm.phoneUpdated },
                            model: {
                              value: _vm.form_.evpaEmergencyContactNumber,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form_,
                                  "evpaEmergencyContactNumber",
                                  $$v
                                )
                              },
                              expression: "form_.evpaEmergencyContactNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "",
                        label: _vm.$t("register.form.emergency.medic"),
                        "label-for": "",
                        description: _vm.$t("register.form.emergency.medicd"),
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "textarea",
                          placeholder: "",
                          rows: "2",
                          "max-rows": "6",
                        },
                        model: {
                          value: _vm.form.evpaMedicalTreatment,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "evpaMedicalTreatment", $$v)
                          },
                          expression: "form.evpaMedicalTreatment",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        id: "acceptance",
                        name: "acceptance",
                        value: "accepted",
                        "unchecked-value": "not_accepted",
                      },
                      model: {
                        value: _vm.formChecked,
                        callback: function ($$v) {
                          _vm.formChecked = $$v
                        },
                        expression: "formChecked",
                      },
                    },
                    [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("register.form.acceptance")),
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "clearfix" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            block: "",
                            type: "submit",
                            variant: "primary",
                            size: "lg",
                            disabled: _vm.loading,
                          },
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", {
                                attrs: { small: "", type: "grow" },
                              })
                            : _vm._e(),
                          _vm._v(" " + _vm._s(_vm.$t("register.form.btn"))),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modalData == "FRIENDSHIP"
        ? _c(
            "div",
            { attrs: { id: "friendshipForm" } },
            [
              _c(
                "div",
                { staticClass: "formTitle" },
                [
                  _c("svg-image", { attrs: { image: "iconFriendship" } }),
                  _vm._v(" "),
                  _c("h5", [_vm._v(_vm._s(_vm.$t("friendship.modal.head")))]),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { attrs: { align: "center" } }, [
                _vm._v(_vm._s(_vm.$t("friendship.modal.desc"))),
              ]),
              _vm._v(" "),
              _c(
                "p",
                { attrs: { align: "center" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        to: "https://borobudurmarathon.com/friendship-run",
                        pill: "",
                        variant: "outline-secondary",
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("friendship.modal.cta")) + " "),
                      _c("b-icon", { attrs: { icon: "arrow-right" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "friendshipInfo" },
                [
                  _c(
                    "b-col",
                    [
                      _c("b-icon", {
                        staticStyle: { width: "120px", height: "120px" },
                        attrs: { icon: "flag" },
                      }),
                      _vm._v(" "),
                      _c("h5", [
                        _vm._v(_vm._s(_vm.$t("friendship.modal.icon1h"))),
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("friendship.modal.icon1d")),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-icon", {
                        staticStyle: { width: "120px", height: "120px" },
                        attrs: { icon: "map" },
                      }),
                      _vm._v(" "),
                      _c("h5", [
                        _vm._v(_vm._s(_vm.$t("friendship.modal.icon2h"))),
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("friendship.modal.icon2d")),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-icon", {
                        staticStyle: { width: "120px", height: "120px" },
                        attrs: { icon: "credit-card" },
                      }),
                      _vm._v(" "),
                      _c("h5", [
                        _vm._v(_vm._s(_vm.$t("friendship.modal.icon3h"))),
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("friendship.modal.icon3d")),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "wonder" },
                [
                  _c("b-icon", {
                    staticStyle: { width: "75px", height: "75px" },
                    attrs: { icon: "check-circle" },
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.$t("friendship.modal.msg")))]),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-form", { on: { submit: _vm.doRegister } }, [
                _c(
                  "div",
                  { staticClass: "clearfix" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          block: "",
                          type: "submit",
                          variant: "primary",
                          size: "lg",
                        },
                      },
                      [
                        _vm.loading
                          ? _c("b-spinner", {
                              attrs: { small: "", type: "grow" },
                            })
                          : _vm._e(),
                        _vm._v(" " + _vm._s(_vm.$t("friendship.modal.btn"))),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/RegistrationModal.vue